const idbService = (app) => {
    function openIndexedDB(version = 1) {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open("bratags", version)

            request.onupgradeneeded = (event) => {
                const db = event.target.result

                    ;['shows', 'userShows'].forEach((storeName) => {
                        if (!db.objectStoreNames.contains(storeName)) {
                            db.createObjectStore(storeName, { keyPath: 'id' })
                        }
                    })

                console.log('Database upgraded to version', version)
            }

            request.onsuccess = (event) => resolve(event.target.result)
            request.onerror = (event) => reject(event.target.error)
        })
    }

    // Function to get the data from IndexedDB
    async function getDataFromIndexedDB(storeName, id) {
        const db = await openIndexedDB()

        return new Promise((resolve, reject) => {
            const transaction = db.transaction([storeName], 'readonly')
            const objectStore = transaction.objectStore(storeName)

            if (!id) {
                const request = objectStore.getAll()

                request.onsuccess = (event) => {
                    // Return an array of .data values
                    resolve(event.target.result.map(record => ({ ...record.data, id: record.id })))
                }
                request.onerror = (event) => reject(event.target.error)
            } else {
                const request = objectStore.get(id)

                request.onsuccess = (event) => {
                    resolve(event.target.result ? event.target.result.data : undefined)
                }
                request.onerror = (event) => reject(event.target.error)
            }
        })
    }


    async function checkIfDataExists(id, storeName) {
        const db = await openIndexedDB()

        return new Promise((resolve, reject) => {
            const transaction = db.transaction([storeName], 'readonly')
            const objectStore = transaction.objectStore(storeName)
            const request = objectStore.getKey(id)

            request.onsuccess = (event) => resolve(!!event.target.result)
            request.onerror = (event) => reject(event.target.error)
        })
    }

    async function executeIndexedDBOperation(storeName, callback) {
        const db = await openIndexedDB()

        return new Promise((resolve, reject) => {
            const transaction = db.transaction([storeName], 'readwrite')
            const objectStore = transaction.objectStore(storeName)
            const request = callback(objectStore)

                ; (Array.isArray(request) ? request : [request]).forEach(request => {
                    request.onsuccess = () => resolve()
                    request.onerror = (event) => reject(event.target.error)
                })
        })
    }

    async function saveDataToIndexedDB(storeName, data, id) {
        if (Array.isArray(data)) {
            const idSuffix = id
            // Handle array of { id, data } entries
            // console.log('Saving array of data to IndexedDB', storeName, data)
            
            await executeIndexedDBOperation(storeName, (objectStore) => data.map(({ id, ...dataObj }) => {
                if (id !== undefined) {
                    const storeId = idSuffix ? `${id}-${idSuffix}` : id

                    // console.log('Saving data to IndexedDB', storeId, { lastUpdated: Date.now(), ...dataObj })

                    app.config.globalProperties.$emitter.emit(`idb:updated:${storeName}`, { id: storeId, data: dataObj })

                    return objectStore.put({ id: storeId, data: { lastUpdated: Date.now(), ...dataObj } })
                }
            }))
        } else {
            // Handle single { id, data } entry
            await executeIndexedDBOperation(storeName, (objectStore) => {
                app.config.globalProperties.$emitter.emit(`idb:updated:${storeName}`, { id, data })
                return objectStore.put({ id, data: { lastUpdated: Date.now(), ...data } })
            })
        }
    }


    async function deleteDataFromIndexedDB(id, storeName) {
        await executeIndexedDBOperation(storeName, (objectStore) =>
            objectStore.delete(id)
        )
        app.config.globalProperties.$emitter.emit(`idb:deleted:${storeName}`, { id })
    }

    return { getDataFromIndexedDB, checkIfDataExists, saveDataToIndexedDB, deleteDataFromIndexedDB }
}

export default {
    async install(app) {
        const service = idbService(app)

        app.config.globalProperties.$idb = service

        if (app.provide) {
            // might be called from sw.js
            app.provide('$idb', service)
        }

        return app
    }
}